import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ChevronLeft({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ChevronLeft.Outline {...props} />
  ) : (
    <ChevronLeft.Solid {...props} />
  );
}

ChevronLeft.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ChevronLeft.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M15.3748 5.25024L8.62476 12.0002L15.3748 18.7502"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
